import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import { Link } from 'react-router-dom';

import AuthLayout, { TRUE_DARK, TRUE_MUTED, primaryButtonSx, strongLinkStyle } from './auth/AuthLayout';

const baseUrl = process.env.REACT_APP_BASE_URL || '';

const RequestPasswordReset = () => {

    const [email, setEmail] = React.useState('');
    const [emailSent, setEmailSent] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    
    const handleRequestPasswordReset = async () => {
        setLoading(true);
        await fetch(`${baseUrl}/management/request-password-reset/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email
            })
        });
        setLoading(false); 
        setEmail('');
        setEmailSent(true);
    }

    return (
        <AuthLayout
            title={emailSent ? 'Revisa tu correo' : 'Restablece tu contraseña'}
            subtitle={emailSent
                ? 'Te enviamos un enlace para restablecer tu contraseña. Contacta a tu administrador si no recibes el correo.'
                : 'Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.'}
        >
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                    <CircularProgress sx={{ color: TRUE_DARK }} />
                </Box>
            ) : !emailSent && (
                <>
                    <TextField
                        id="email"
                        label="Correo electrónico"
                        variant="outlined"
                        fullWidth
                        size="small"
                        autoFocus
                        sx={{ mb: 3 }}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <Button variant="contained" fullWidth sx={primaryButtonSx} onClick={handleRequestPasswordReset}>
                        Enviar enlace
                    </Button>
                </>
            )}
            <Typography variant="body2" sx={{ textAlign: 'center', color: TRUE_MUTED, fontFamily: 'Inter, sans-serif', mt: 3 }}>
                <Link to="/login" style={strongLinkStyle}>
                    Volver a iniciar sesión
                </Link>
            </Typography>
        </AuthLayout>
    )
};

export default RequestPasswordReset;
